import MatrixTextField from "./MatrixTextField";
import parse from "html-react-parser";

export default function MatrixTextWithImageField(content, i) {
    if (!content?.content) {
        return <></>
    }

    return (
        <section key={i}>
            <div className={'grid gap-10 my-10 md:my-20 md:grid-cols-2'}>
                <div
                    className="wysiwyg lg:max-w-5xl lg:ml-0 prose prose-base md:prose-xl prose-strong:text-olaf-green-500 prose-headings:text-olaf-green-500 prose-a:text-olaf-green-500 prose-a:text-initial">
                    {parse(content?.content?.text)}
                </div>
                <img src={content?.content.image_1?.url} alt={content?.alt} width={'100%'} height={350}
                     className={'w-full object-cover max-h-[350px] md:max-h-[unset] md:h-[350px]'}/>
            </div>
        </section>
    );
}
